export const REGO_SEARCH = 'regoSearch'
export const REGO_REMOVE = 'regoRemove'
export const REGO_SEARCHED = 'regoSearched'
export const RESET_REGO_SEARCHED = 'resetRegoSearched'
export const REGO_LOOKUP_COMPLETED = 'agRegoLookupCompleted'
export const RESET_REGO_LOOKUP_COMPLETED = 'resetAGRegoLookupCompleted'
